import { QrReader } from '@cmdnio/react-qr-reader';
import { useEffect, useState } from 'react';
import type { QRScannerProps, ScanResult } from 'types/propTypes';

const QRScanner = ({ onScan }: QRScannerProps) => {
    const [result, setResult] = useState<ScanResult | null>(null);

    useEffect(() => {
        if (result) {
            onScan(result);
        }
    }, [result, onScan]);

    return (
        <div>
            <QrReader
                constraints={{ facingMode: 'environment' }}
                onResult={(qrResult, error) => {
                    if (qrResult) {
                        setResult({ url: qrResult.getText() });
                    } else if (error instanceof Error) {
                        setResult({
                            url: '',
                            errorName: error.name,
                            errorMessage: error.message,
                        });
                    }
                }}
                videoContainerStyle={{ position: 'static', padding: '0px' }}
                videoStyle={{ background: 'black' }}
            />
        </div>
    );
};

export default QRScanner;
